<template>
  <div class="w-100 my-5">
    <div class="row my-5" v-if="eventList">
      <div class="col-sm-12" v-for="(item, index) in eventList" :key="(item, index)">
        <v-card class="my-2 box-white d-flex flex-column">
          <div class="m-2 row">
            <span class="col-sm-3">{{ item.eventId }}</span>
            <span class="col-sm-4">{{ item.name }}</span>
            <span class="col-sm-3">{{ getDecimalFormat(item.soldQuantity || 0) }}&nbsp;/&nbsp;{{ getDecimalFormat(item.totalQuantity || 0) }}</span>
            <v-btn class="ml-auto mr-5 button-normal" small @click="getTicketListTask(index)">
              <span>Set Sold/Total Quantity</span>
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>
    <div class="py-40 center" v-else>
      <p>{{ $t('please_wait') }}</p>
      <b-spinner type="grow"></b-spinner>
    </div>
  </div>
</template>

<script>
import { httpsCallable } from 'firebase/functions';
import { firestore, functions } from '../../../main';
import { collection, query, getDocs, where } from 'firebase/firestore';
import { showLoading, getDecimalFormat } from '../../../functions';

export default {
  name: 'SetTicketSoldTotalQuantity',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    eventList() {
      return this.$store.state.eventList;
    }
  },
  mounted() {
    if (window.location.hostname !== 'localhost') {
      this.$router.push('/');
    }
  },
  methods: {
    getDecimalFormat,
    getTicketListTask(index) {
      if (index < 0 || index >= this.eventList.length) {
        alert('finish');
        return;
      }
      const eventInfo = this.eventList[index];
      if (!eventInfo) {
        this.$toast.error('unknown error');
        return;
      }
      const loader = showLoading(this);
      const q = query(collection(firestore, 'ticket'), where('eventId', '==', eventInfo.eventId));
      getDocs(q).then(querySnapshot => {
        loader.hide();
        var soldQuantity = 0;
        var totalQuantity = 0;
        querySnapshot.forEach(doc => {
          const data = doc.data();
          soldQuantity += data.soldQuantity || 0;
          totalQuantity += data.totalQuantity || 0;
        });
        const origSoldQuantity = eventInfo.soldQuantity || 0;
        const origTotalQuantity = eventInfo.totalQuantity || 0;
        if (origSoldQuantity === soldQuantity && origTotalQuantity === totalQuantity) {
          this.$toast.success('Correct');
          //console.log(`[${index + 1} / ${this.eventList.length}] [${eventInfo.eventId}], [${eventInfo.name}], Original - [${origSoldQuantity} / ${origTotalQuantity}], Correct - [${soldQuantity} / ${totalQuantity}]`);
          //this.$toast.success(`[${index + 1} / ${this.eventList.length}] [${eventInfo.eventId}], [${eventInfo.name}], Original - [${origSoldQuantity} / ${origTotalQuantity}], Correct - [${soldQuantity} / ${totalQuantity}]`);
        } else {
          //console.log(`[${index + 1} / ${this.eventList.length}] [${eventInfo.eventId}], [${eventInfo.name}], Original - [${origSoldQuantity} / ${origTotalQuantity}], Correct - [${soldQuantity} / ${totalQuantity}]`);
          if (confirm(`Original - [${origSoldQuantity} / ${origTotalQuantity}], Correct - [${soldQuantity} / ${totalQuantity}], Fix now?`)) {
            this.setSoldTotalQuantityTask(eventInfo.eventId, soldQuantity, totalQuantity);
          }
        }
        /*setTimeout(() => {
          this.getTicketListTask(index + 1);
        }, 200);*/
      }).catch(error => {
        loader.hide();
        this.$toast.error('Unexpected error occurs - ' + error.message);
      });
    },
    setSoldTotalQuantityTask(eventId, soldQuantity, totalQuantity) {
      if (!eventId || (!soldQuantity && !totalQuantity)) {
        this.$toast.info('Invalid event ID.');
        return;
      }
      const params = {
        functionName: 'setTicketSoldTotalQuantity',
        eventId: eventId,
        soldQuantity: soldQuantity,
        totalQuantity: totalQuantity
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    }
  }
};
</script>